import {Fragment} from 'react'
import {Col, Modal as BootstrapModal, ModalBody, ModalHeader, Row} from 'reactstrap'

import Modal from '../../../../../shared/components/Modals/Modal.jsx'
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx"
import SecondaryButton from "../../../../../shared/components/Styled/Buttons/SecondaryButton.jsx"
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
import DivBlueBg from "../../../../../shared/components/Styled/Blocs/DivBlueBg.jsx"
import ParagraphCenter from "../../../../../shared/components/Styled/ParagraphCenter.jsx"

class ReScheduleModal extends Modal {
  constructor(props) {
    super(props)

    this.state = {
      updateText: false,
    }

    this.close = () => this.props.closeModal()
  }

  render() {
    const modalProps = {
      className: 'modal-email'
    }

    modalProps.toggle = this.close

    return (
      <BootstrapModal {...modalProps} isOpen={this.props.isOpen} size="lg">
        <ModalHeader {...modalProps}> Un problème avec votre rendez-vous ?</ModalHeader>
        <ModalBody>
          {this.state.updateText
            ? <Fragment>
              <Row className={"mx-4"}>
                <Col className={"p-4"}>
                  <ParagraphLeftAlign>
                    Veuillez nous excuser pour ce désagrément. Nous accordons une importance toute particulière à ces
                    rendez-vous qui nous permettent d'en savoir plus sur
                    vous tout en qualifiant votre profil.
                  </ParagraphLeftAlign>
                  <ParagraphLeftAlign className={"mt-2"}>
                    Ne pas honorer ces entretiens est donc totalement involontaire de notre part. Il arrive cependant
                    parfois qu'un imprévu ou problème technique lié à
                    la gestion des agendas créent ce genre de situation.
                  </ParagraphLeftAlign>
                  <ParagraphLeftAlign className={"mt-2"}>
                    Nous vous proposons de planifier un nouveau rendez-vous dans les plus brefs délais pour nous
                    rencontrer :
                  </ParagraphLeftAlign>
                </Col>
              </Row>
              <Row className={"m-4"}>
                <Col className={"text-center"}>
                  <PrimaryButton className={"mx-auto"} style={{textWrap: 'wrap'}}
                    onClick={this.props.openCalendlyWidget}> Je planifie un nouveau
                    rendez-vous </PrimaryButton>
                </Col>
              </Row>
            </Fragment>
            : <Row>
              <Col className={"p-2 col-lg-6 col-12"}>
                <DivBlueBg className={"ml-3  mr-3 mr-lg-0 p-2"}>
                  <ParagraphLeftAlign className={"mb-2"}
                    text="Vous n'avez pu vous présenter à votre rendez-vous ? Aucun problème, vous pouvez en replanifier un nouveau :"/>
                  <ParagraphCenter><PrimaryButton style={{textWrap: 'wrap'}} className={"mx-auto"}
                    onClick={this.props.openCalendlyWidget}> Je planifie un nouveau
                    rendez-vous </PrimaryButton></ParagraphCenter>
                </DivBlueBg>
              </Col>
              <Col className={"p-2 col-lg-6 col-12"}>
                <DivBlueBg className={"mr-3 ml-3 ml-lg-0 p-2"}>
                  <ParagraphLeftAlign className={"mb-4"}
                    text="Votre interlocuteur ne s'est pas connecté à votre rendez-vous en visio ? "/>
                  <ParagraphCenter>
                    <SecondaryButton className={"mx-auto"} style={{textWrap: 'wrap'}}
                      onClick={() => this.setState({updateText: true})}> Mon interlocuteur ne s'est pas
                      connecté </SecondaryButton>
                  </ParagraphCenter>
                </DivBlueBg>
              </Col>
            </Row>}
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default ReScheduleModal

/*
export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(withRouter(ReSchedulModal));*/
